import EditBrandContainer from "./EditBrandContainer";
export default EditBrandContainer;
